import Typography from 'design-system/components/Typography/Typography';
import { HTMLAttributes } from 'react';

const LibraryMaterialDetailUpgradePlanSection = ({
  mainTitle = 'Tài liệu Premium',
  subtTitle = 'Nâng cấp thành viên ngay',
  ...divProps
}: {
  mainTitle?: string;
  subtTitle?: string;
} & React.DetailedHTMLProps<
  HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => {
  return (
    <div {...divProps}>
      <Typography
        variant={'heading1'}
        className="bg-Other/Upgradeaccount bg-clip-text text-transparent"
      >
        {mainTitle}
      </Typography>
      <Typography
        variant={'body4'}
        className="text-Text/Lightbackground/Secondary"
      >
        {subtTitle}
      </Typography>
    </div>
  );
};

export default LibraryMaterialDetailUpgradePlanSection;
